export default "__VITE_ASSET__Cv1I4uLa__"